import React from "react";

const InvoiceSearchContext = React.createContext({});

export const context = InvoiceSearchContext;
export const InvoiceSearchProvider = InvoiceSearchContext.Provider;
export const InvoiceSearchConsumer = InvoiceSearchContext.Consumer;
